import { render, staticRenderFns } from "./DynamicInboundCallsSettings.vue?vue&type=template&id=534fe6e2"
import script from "./DynamicInboundCallsSettings.vue?vue&type=script&lang=js"
export * from "./DynamicInboundCallsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports